var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7291 16.9921H2.75536C1.23894 16.9921 7.62939e-05 15.7533 7.62939e-05 14.2368V3.26309C7.62939e-05 1.74667 1.23894 0.507812 2.75536 0.507812H13.7291C15.2455 0.507812 16.4844 1.74667 16.4844 3.26309V14.2368C16.4844 15.76 15.2523 16.9921 13.7291 16.9921Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.24543 12.9841C7.11488 12.9841 6.05203 12.5441 5.2532 11.7453C4.45438 10.9464 4.01434 9.8836 4.01434 8.75306C4.01434 7.62251 4.45438 6.55966 5.2532 5.76083C6.05203 4.96201 7.11488 4.52197 8.24543 4.52197C9.37597 4.52197 10.4388 4.96201 11.2376 5.76083C12.0365 6.55966 12.4765 7.62251 12.4765 8.75306C12.4765 9.8836 12.0365 10.9464 11.2376 11.7453C10.4321 12.5441 9.37597 12.9841 8.24543 12.9841ZM8.24543 5.42235C6.41083 5.42235 4.91472 6.91169 4.91472 8.75306C4.91472 10.5877 6.40406 12.0838 8.24543 12.0838C10.08 12.0838 11.5761 10.5944 11.5761 8.75306C11.5694 6.91846 10.08 5.42235 8.24543 5.42235Z",
    fill: "#1D1D1D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3012 4.38357C13.7499 4.38357 14.1136 4.01985 14.1136 3.57118C14.1136 3.12251 13.7499 2.75879 13.3012 2.75879C12.8526 2.75879 12.4889 3.12251 12.4889 3.57118C12.4889 4.01985 12.8526 4.38357 13.3012 4.38357Z",
    fill: "#1D1D1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.dff3e039f7b56b9c3e029605677026c5.svg";
export { ForwardRef as ReactComponent };